import React, { useState, useRef } from 'react';
import { Row, Col, Button, Input ,Modal} from 'antd';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { EditAppInfo, DeleteApp, GetAppInfo } from '../gqls'
import Client from '../../../../lib/gqlClient';
const VersionItemPage = (props) => {
    const [divHeight, setDivHeight] = useState(0);
    const ref = useRef(null);

    const { TextArea } = Input;
    const navigate = useNavigate();
    const [itemDescription, setItemDescription] = useState([]);
    const [isItemEdit, setIsItemEdit] = useState(false);
    const [openModal, setOpenModal] = useState(false);

    React.useEffect(() => {
        setDivHeight(ref.current.clientHeight);

    }, [])

    const showInpDescription = e => {
        setItemDescription(e.target.value);
    }
    function onEditAppInfo() {
        setIsItemEdit(true)
    }
  
    function onStartAppInfo(id) {
        console.log(props)
        navigate('/developerCenter/apk/appDetails?id=' + id
        )
    }
    function onDeleteApp(id) {
        Client(
            null,
            {
                deleteAppId: id,
            }, DeleteApp
        ).then((res) => {
            setOpenModal(false)
            console.log(res)
            if (res !== null) {

            }
            props.onRefresh()

        }).catch(e => {
            setOpenModal(false)
            props.onRefresh()
        })
    }
    function onEditOk(id) {
        setIsItemEdit(false)
        Client(
            null,
            {
                editAppInfoId: id,
                description: itemDescription,
            }, EditAppInfo
        ).then((res) => {
            console.log(res)
            if (res !== null) {

            }
            props.onRefresh()
        }).catch(e => {
            props.onRefresh()
        })

    }
    function onEditNo() {
        setIsItemEdit(false)
    }
    function onDelete(){
        onDeleteApp(props.item._id)
    }
    return (
        <Row >
            <Col style={{ width: '50px', height: divHeight }}>
                <div>
                    <div style={{marginLeft:'5px', width: '1px', height: '20px', backgroundColor: '#D8D8D8', }}></div>
                    <div style={{ width: '11px', height: '11px', backgroundColor: '#D8D8D8', borderRadius: "10px", }}></div>
                    <div style={{marginLeft:'5px', width: '1px', height: divHeight - 30, backgroundColor: '#D8D8D8', }}></div>
                </div>

            </Col>
            <Col ref={ref} >
                <div style={{marginTop:'10px',fontSize:'18px'}}>{props.item.platform === 'IOS'?props.item.version+'(Build '+props.item.bundleVersion+")":props.item.versionName+'(Build '+props.item.versionCode+")"}</div>
                <div style={{fontSize:'14px',}}>{props.item.createdAt.substring(0, 10) + " " + props.item.createdAt.substring(11, 19)}</div>
                <div style={{ display: isItemEdit ? 'none' : '',fontSize:'16px', }}>{props.item.description}</div>
                <TextArea
                    value={itemDescription}
                    onChange={showInpDescription}
                    style={{ width: '200px', height: '50px', resize: 'none', display: isItemEdit ? '' : 'none' }} />
                <Row style={{ marginTop: '10px', display: isItemEdit ? 'none' : '' ,marginBottom:'20px'}}>
                    <Col >
                        <Button disabled={props.isAllowEditing} onClick={() => onEditAppInfo()} style={{ height: '30px', resize: 'none', borderRadius: "15px", }}>
                            编辑
                        </Button>
                    </Col>
                    <Col >
                        <Button onClick={() => onStartAppInfo(props.item._id)} style={{ marginLeft: '10px', height: '30px', resize: 'none', borderRadius: "15px", }}>
                            预览
                        </Button>
                    </Col>
                    <Col >
                        <Button disabled={props.itemSize===1||props.isAllowEditing} onClick={() => setOpenModal(true)} style={{ marginLeft: '10px', height: '30px', resize: 'none', borderRadius: "15px", }}>
                            删除
                        </Button>
                    </Col>
                </Row>
                <Modal
                    closable={false}
                    centered
                    open={openModal}
                    footer={null}
                    width={320}
                    destroyOnClose={true}
                    maskStyle={{ animation: 'none', background: 'ffffff', opacity: '0.5', padding: '0px' }}
                    bodyStyle={{ padding: '0px', width: '320px', background: 'ffffff', borderRadius: '10px' }}
                    style={{ borderRadius: "10px", overflow: "auto" }}
                >
                    <div style={{ fontSize: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '112px' }}>
                        <div >{props.item.platform === 'IOS'?'删除'+props.item.version+'(Build '+props.item.bundleVersion+")":'删除'+props.item.versionName+'(Build '+props.item.versionCode+")"}</div>
                    </div>

                    <div style={{ height: '1px', width: '320px', background: 'rgba(0, 0, 0, 0.1)' }}></div>
                    <Row>
                        <Col span={'159.5px'}>
                            <Button type="text" onClick={() => onDelete()} style={{ color: '#FF5300', fontSize: '16px', width: '159.5px', height: '56px' }}>Delete</Button>
                        </Col>
                        <Col span={'1px'}>
                            <div style={{ height: '56px', width: '1px', background: 'rgba(0, 0, 0, 0.1)' }}></div>
                        </Col>
                        <Col span={'159.5px'}>
                            <Button type="text" onClick={() => setOpenModal(false)} style={{ fontSize: '16px', width: '159.5px', height: '56px' }}>Cancel</Button>
                        </Col>
                    </Row>

                </Modal>
                <Row style={{ marginTop: '10px', display: isItemEdit ? '' : 'none' ,marginBottom:'20px'}}>
                    <Col >
                        <Button onClick={() => onEditOk(props.item._id)} style={{ height: '30px', resize: 'none', borderRadius: "15px", }}>
                            确认
                        </Button>
                    </Col>
                    <Col >
                        <Button onClick={() => onEditNo()} style={{ marginLeft: '10px', height: '30px', resize: 'none', borderRadius: "15px", }}>
                            取消
                        </Button>
                    </Col>
                </Row>
            </Col>
        </Row>
    )

}

export default VersionItemPage